export const envVars = {
  APP_NAME: 'Dashboard Header',
  PUBLIC_URL: process.env.PUBLIC_URL || '',
  APP_ENV: process.env.APP_ENV || '',
  PORT: process.env.PORT || '',
  PAYROLL_URL: process.env.PAYROLL_URL || '',
  PAYROLL_DASHBOARD_URL: process.env.PAYROLL_DASHBOARD_URL || '',
  WEBSITE_URL: process.env.WEBSITE_URL || '',
  LEAD_FORM_AUTO_DOMAIN_NAME: process.env.LEAD_FORM_AUTO_DOMAIN_NAME || '',
  LEAD_FORM_HOME_DOMAIN_NAME: process.env.LEAD_FORM_HOME_DOMAIN_NAME || '',
  LOGIN_URL: process.env.LOGIN_URL || '',
  SUPPORT_URL: 'https://ajuda.creditas.com',
  APP_STORE_URL: 'https://creditasapp.onelink.me/q3aj/924b0bf',
  CUSTOMER_ONBOARDING_API: process.env.CUSTOMER_ONBOARDING_API || '',
};
